module.exports = __webpack_public_path__ + "bacc0dca3d5fb38c8603d54218fe0f06.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tempunavailable.png
// module id = 182
// module chunks = 0